import { html, View } from 'rune-ts';
import klass from './RealtimeView.module.scss';
import { IconView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/IconView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';
import { CardProductError } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductView.ts';

export type TProps = {
  size: 'Medium' | 'Small';
  ordered_at: string;
  currentTime: string;
};

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=26351-75864&m=dev
 */
export class RealtimeView extends View<TProps> {
  setCurrentTime(currentTime: string) {
    this.data.currentTime = currentTime;
    this.redraw();
  }

  protected override template({ size, ordered_at, currentTime }: TProps) {
    const days = differenceInDays(new Date(currentTime), new Date(ordered_at));

    const hours = differenceInHours(new Date(currentTime), new Date(ordered_at));

    const minutes = differenceInMinutes(new Date(currentTime), new Date(ordered_at));

    const seconds = differenceInSeconds(new Date(currentTime), new Date(ordered_at));

    let displayTime;
    if (days >= 1) {
      displayTime = ET('card_product::realtime::days', { days });
    } else if (hours >= 1) {
      displayTime = ET('card_product::realtime::hours', { hours });
    } else if (minutes >= 1) {
      displayTime = ET('card_product::realtime::minutes', { minutes });
    } else {
      displayTime = ET('card_product::realtime::seconds', { seconds });
    }

    if (size === 'Medium') {
      return html`<span class="${classes(klass.review, klass.size_medium)}">
        <span class="${classes(klass.icon, klass.size_medium)}">${new IconView({ type: 'Clock' })}</span>

        <span class="${classes(klass.text, klass.size_medium)}">
          <span class="${font('12_bold')}">${displayTime}</span>

          <span class="${font('12_medium')}">${ET('card_product::realtime::sold_ago')}</span>
        </span>
      </span>`;
    } else if (size === 'Small') {
      return html`<span class="${classes(klass.review, klass.size_small)}">
        <span class="${classes(klass.icon, klass.size_small)}">${new IconView({ type: 'Clock' })}</span>

        <span class="${classes(klass.text, klass.size_small)}">
          <span class="${font('12_bold')}">${displayTime}</span>

          <span class="${font('12_medium')}">${ET('card_product::realtime::sold_ago')}</span>
        </span>
      </span>`;
    } else {
      throw new CardProductError();
    }
  }
}
